export class Todo {
    constructor(public text: string, public type: string, public isChecked: boolean) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/todo/index.ts